import { useEffect } from "react";

const SITE = "https://veloraintelligence.ai";
const OG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/901498b5-24b5-44b0-8dcc-4eb0ab5694c3/images/726d9066bc757f936c8a79784f0a6e5a7169c02045da1a904498e2660649274e.jpeg";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useSeo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | Velora Intelligence`
      : "Velora Intelligence — Smarter Crypto Decisions. Powered by Intelligence.";
    document.title = fullTitle;
    const url = `${SITE}${path}`;

    setMeta("name", "description", description);
    setLink("canonical", url);

    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Velora Intelligence");
    setMeta("property", "og:image", OG_IMAGE);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", OG_IMAGE);
  }, [title, description, path]);
};
